<div class="grid-6 copo-container footer-margin" *ngIf="batchData">
	<div class="grid-column-one-full">
		<mat-expansion-panel [expanded]="true" class="card-info-block">
			<mat-expansion-panel-header>
				<mat-panel-title class="card-content-title">
					<span translate>aqdb.other.characteristics</span>
				</mat-panel-title>
			</mat-expansion-panel-header>
			<mat-divider class="margin-expansion-panel"></mat-divider>
			<div class="card-content-block quadruple-column">
				<div class="card-contents-infos">
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.mill.code</div>
						<div class="card-content-value">{{ batchData.receivingMillCode ? (batchData.receivingMillCode | copoNumber:'length-m') : UNDERSCORE }}</div>
					</div>
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.metal.unit.mill</div>
						<div class="card-content-value">{{ batchData.metalUnitMill ? (batchData.metalUnitMill | copoNumber:'number') : UNDERSCORE }}</div>
					</div>
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.metal.unit.date</div>
						<div class="card-content-value">{{ batchData.metalUnitDate ? batchData.metalUnitDate : UNDERSCORE }}</div>
					</div>
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.av.date</div>
						<div class="card-content-value">{{ batchData.readyToShipDate ? (batchData.readyToShipDate | copoDate:'date') : UNDERSCORE}}</div>
					</div>
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.external.diameter</div>
						<div class="card-content-value">{{ batchData.externalDiameter ? (batchData.externalDiameter | copoNumber:'diameter') : UNDERSCORE }}</div>
					</div>
				</div>
				<div class="card-contents-infos">
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.mill.internal.ref</div>
						<div class="card-content-value">{{ batchData.internalMillReference ? batchData.internalMillReference : UNDERSCORE }}</div>
					</div>
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.user</div>
						<div class="card-content-value">{{ batchData.endUser ? batchData.endUser: UNDERSCORE }}
						</div>
					</div>
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.aspect.side.1</div>
						<div class="card-content-value">{{ batchData.surfaceAspectCodeFace1 ? batchData.surfaceAspectCodeFace1: UNDERSCORE }}
						</div>
					</div>
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.aspect.side.2</div>
						<div class="card-content-value">{{ batchData.surfaceAspectCodeFace2 ? batchData.surfaceAspectCodeFace2: UNDERSCORE }}
						</div>
					</div>
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.internal.diameter</div>
						<div class="card-content-value">{{ batchData.internalDiameter ? batchData.internalDiameter: UNDERSCORE }}</div>
					</div>
				</div>
				<div class="card-contents-infos">
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.code</div>
						<div class="card-content-value">{{ batchData.technicalGrade ? (batchData.technicalGrade | copoNumber:'number') : UNDERSCORE }}</div>
					</div>
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.release</div>
						<div class="card-content-value">{{ batchData.technicalGradeRelease ? (batchData.technicalGradeRelease | copoNumber:'number') : UNDERSCORE }}</div>
					</div>
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.description</div>
						<div class="card-content-value">{{ batchData.technicalGradeLabel ? batchData.technicalGradeLabel: UNDERSCORE }}</div>
					</div>
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.mill.cast.number</div>
						<div class="card-content-value">{{ batchData.heatNumber ? batchData.heatNumber : UNDERSCORE }}</div>
					</div>
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.surface.mu</div>
						<div class="card-content-value">{{ batchData.srf ? (batchData.srf | copoNumber:'number') : UNDERSCORE }}</div>
					</div>
				</div>
				<div class="card-contents-infos">
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.casting.mill</div>
						<div class="card-content-value">{{ batchData.castingMill ? (batchData.castingMill | copoNumber:'number') : UNDERSCORE }}</div>
					</div>
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.casting.date</div>
						<div class="card-content-value">{{ batchData.castingDate ? batchData.castingDate: UNDERSCORE }}</div>
					</div>
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.segments.no</div>
						<div class="card-content-value">{{ batchData.numberOfSegments ? (batchData.numberOfSegments | copoNumber:'number') : UNDERSCORE }}</div>
					</div>
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.complete.message</div>
						<div *ngIf="batchData.completeFlag === 'O'">
							<span translate>aqdb.flag.complete</span>
						</div>
						<div *ngIf="batchData.completeFlag === 'N'">
							<span translate>aqdb.flag.incomplete</span>
						</div>
						<div *ngIf="batchData.completeFlag !== 'O' && batchData.completeFlag !== 'N'">
							{{ UNDERSCORE }}
						</div>
					</div>
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.origin.mill</div>
						<div class="card-content-value">{{ batchData.parentMuOrigin ? batchData.parentMuOrigin : UNDERSCORE }}</div>
					</div>
				</div>
			</div>
		</mat-expansion-panel>
	</div>
</div>
